export class TeamSingle {
  constructor() {
    this.root = document.querySelector('[data-team-single]')
    if (!this.root) return

    this.tabsRoot = this.root.querySelector('[data-team-tabs]')
    if (!this.tabsRoot) return

    this.tabs = [...this.tabsRoot.querySelectorAll('[data-team-tab]')]
    this.panels = [...this.tabsRoot.querySelectorAll('[data-team-panel]')]
    if (!this.tabs.length) return

    this.bindTabs()
  }

  bindTabs() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index))
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index))
    })
  }

  onKeydown(event, index) {
    const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End']
    if (!keys.includes(event.key)) return

    event.preventDefault()
    let next = index

    if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length
    if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length
    if (event.key === 'Home') next = 0
    if (event.key === 'End') next = this.tabs.length - 1

    this.activate(next)
    this.tabs[next].focus()
  }

  activate(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index
      tab.classList.toggle('is-active', active)
      tab.setAttribute('aria-selected', active ? 'true' : 'false')
      tab.tabIndex = active ? 0 : -1
    })

    this.panels.forEach((panel, i) => {
      const active = i === index
      panel.classList.toggle('is-active', active)
      panel.hidden = !active
    })
  }
}
